import { render } from "./ProjectPanel.vue?vue&type=template&id=c84212be"
import script from "./ProjectPanel.vue?vue&type=script&lang=js"
export * from "./ProjectPanel.vue?vue&type=script&lang=js"

import "./ProjectPanel.vue?vue&type=style&index=0&id=c84212be&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__